import AppLayout from '@/layout/AppLayout.vue'
const Details = () => import('@/view/commissions/Details.vue')
const Record = () => import('@/view/commissions/Record.vue')

const routes = {
  path: '/Commissions',
  name: 'Commissions',
  icon: 'icon-a-lianhe40',
  meta: {
    title: 'agent.commission'
  },
  children: [
    {
      path: '/Commissions/Details',
      name: 'CommissionsDetails',
      meta: {
        title: 'commissions.rebateDetail'
      },
      component: Details,
    },
    {
      path: '/Commissions/Record',
      name: 'CommissionsRecord',
      meta: {
        title: 'commissions.rebateRecord'
      },
      component: Record,
    }
  ]
}

const components = {}

export default {
  routes,
  components,
}
